import { FlowNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";
import { extractInputMappings } from "src/flowGraph/canvasSearch/nodesExtractors/utils";

export const extractDecisionFlowFields = (
  data: FlowNodeData,
): SearchableField[] => [
  ...extractInputMappings(data.input_mappings),
  ...Object.values(data.output_mappings).map((mapping) => ({
    id: mapping.id,
    value: `data.${mapping.destination}`,
  })),
];
